.wrapper {
  height: 100%;
  width: 100%;
  padding: 20px;
}
